// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3rc9AqhiPNY69bEJDiRy62 {\n  margin: var(--space-small);\n  padding: calc(var(--space-small) / 2) var(--space-small);\n  border-radius: var(--space-small);\n  background-color: var(--gray);\n  font-size: 1rem;\n}\n", ""]);
// Exports
exports.locals = {
	"tag": "_3rc9AqhiPNY69bEJDiRy62"
};
module.exports = exports;
